import * as Sentry from '@sentry/react';

// Initialised once at app start (imported first in index.js).
// Enabled in production only — dev and test runs are never reported.
// DSN is injected via REACT_APP_SENTRY_DSN environment variable; if the var
// is absent the SDK silently no-ops rather than throwing.

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0.2,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  // Never send raw email addresses in breadcrumbs or request data
  beforeSend(event) {
    return event;
  },
});

export default Sentry;
